<template>
    <div class="logincent">
        <div class="conten" >
            <h2>{{$t('zhmm')}}</h2>
            <van-form  class="fromctent">
                <div class="phone ">
                    <select @click="selectHand">
                        <option :value ="this.address">{{this.address}}</option>
                    </select>
                    <van-field
                    v-model="mobile"
                    :placeholder="$t('sjhm')"
                    :border="true"
                    clearable
                    size='large'
                    />
                </div>
                <van-field
                v-model="password"
                type="password"
                :placeholder="$t('xmm')"
                :border="true"
                right-icon="closed-eye"
                clearable
                size='large'
                />
                <!-- <van-field
                v-model="mobile"
                :placeholder="$t('sjhm')"
                :border="true"
                
                clearable
                size='large'
                /> -->
                <!-- <van-field
                style="margin-bottom:10px"
                    v-model="verify_code"
                    center
                    clearable
                    :placeholder="$t('qsrdxyzm')"
                    >
                    <template #button>
                        <van-button size="small" @click="handldCode" class="codem" :disabled="disabled" color="#48C9B0">
                            {{Codename}}
                        </van-button>
                    </template>
                </van-field> -->

                <!-- <van-field
                v-model="email"
                :placeholder="$t('yx')"
                :border="true"
                
                clearable
                size='large'
                />
                <van-field
                style="margin-bottom:10px"
                    v-model="email_code"
                    center
                    clearable
                    :placeholder="$t('qsryxyzm')"
                    >
                    <template #button>
                        <van-button size="small" @click="handldemailCode" class="codem" :disabled="disabled" color="#48C9B0">
                            {{emailCodename}}
                        </van-button>
                    </template>
                </van-field> -->
                <div style="margin-top: 26px;">
                    <van-button  block color="#48C9B0" class="loginbut" native-type="submit" @click="onSubmit">
                        <span style="font-size: 22px;">{{$t('qd')}}</span>
                    </van-button
                >
                </div>
            </van-form>
            <div class="logintop">
                <div @click="gologin" >{{$t('login')}}</div>
                <!-- <div @click="regin" >{{$t('zc')}}</div> -->
            </div>
            
        </div>
    </div>
</template>
<script>
import MD5 from 'md5'
import { Toast } from 'vant';
export default {
    data(){
        return{
            address:localStorage.getItem('address')?localStorage.getItem('address'):'+86',
            disabled:false,
            Codename:this.$t('fsyzm'),
            emailCodename:this.$t('fsyzm'),
            name:'',
            password:'',
            mobile:'',
            verify_code:'',
            email:'',
            email_code:''
        }
    },
     mounted(){
        // this.address = window.localStorage.getItem("address")?window.localStorage.getItem:'+86'
        // console.log( window.localStorage.getItem("address"))
    },
    methods:{
        selectHand(){
            this.$router.push({path:'/indexbar'})
            
        },
        regin(){
            this.$router.push({ path: '/regin' })
        },
        gologin(){
            this.$router.push({ path: '/login' })
        },
        async onSubmit(){
            // let data = {
            //     method:'email.verify.code',
            //     email:this.email,
            //     email_code:this.email_code
            // }
            // await this.$email(data).then(res=>{
            //     if(res.data.code!='0'){
            //         Toast.fail("邮箱验证码不正确！");
            //         return false
            //     }
            // })
            let mobiles
            if(this.address=="+86"){
                mobiles =this.mobile
            }else{
                mobiles =this.address+'-'+ this.mobile
            }
            let pamars ={
                method:'co.wx.mobile.password.reset',
                mobile: mobiles,
                new_password: this.$md5(this.password)
            }
            await this.$serve(pamars).then(res=>{
                if(res.data.code==0){
                    Toast.success(this.$t('szcg'));
                    this.$router.push({ path: '/login' })
                }else if(res.data.code=='-7'){
                    Toast.fail(this.$t('yzmbzq'));
                }else{
                    Toast.fail(this.$t('szsb'));
                }
            })

        },
        handldemailCode(){
            let data={
                method:'email.send',
                subject:this.$t('zzhmm'),
                to_address:this.email,
                content:this.$t('yzms')
            }
            this.$email(data).then(res=>{
                if(res.data.code=='0'){
                    Toast.success(this.$t('hqyzmcg'));
                    
                }else{
                    Toast.fail(this.$t('hqyzmsb'));
                }
            })
        },
        handldCode(){
            if(!this.name){
                Toast.fail(this.$t('qsryhm'));
            }
            if(!this.mobile){
                Toast.fail(this.$t('qsrsjhm'));
            }
            let data={
                method:'co.sms.code.get',
                name:this.name,
                mobile:this.mobile,
                type:'1'
            }
            this.$https(data).then(res=>{
                if(res.data.code==0){
                    Toast.success(this.$t('hqyzmcg'));
                }else if(res.data.code=='-3'){
                    Toast.fail(this.$t('yhbcz'));
                }else{
                    Toast.fail(this.$t('hqyzmsb'));
                }
            })
        }

    }
}
</script>
<style scoped>
.logincent {
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.conten {
  width: 90%;
  height: auto;
  padding-top: 20px;
  margin-top:12%;
  border-radius: 10px;
  /* box-shadow: #d5d5d5 0px 0px 10px; */
}
.phone{
    display: flex;
    height: 46px;
    border: 1px solid #DBDBDB;
    margin-bottom: 10px;
    border-radius: 5px;
    padding:0px 2px;
}
.phone select{
    height: 42px;
    border: none;
    line-height: 35px;
    padding:2px;
    border-right: 1px solid #DBDBDB;
    background-color: #fff;
    color: #323233;
}
.fromctent .phone >>> .van-cell--large{
    border: none;
    border-radius: 0px;
}  
.fromctent{
    width: 88%;
    margin: 0 auto;
    margin-top:30px;
}
.fromctent >>>.van-field__left-icon .van-icon-friends{
    font-size: 26px;
    margin-left: -5px;
    color: #CCCCCC;
}
.fromctent >>>.van-cell--large{
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    padding: 8px;
    margin-bottom: 10px;
}
.fromctent >>>.van-cell--center{
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    padding: 4px;
}
.fromctent >>>.van-field__left-icon .van-icon-bag{
    font-size: 28px;
    /* margin-left: 2px; */
    color: #CCCCCC;
}
.logintop{
    padding: 0 20px;
    margin-top:30px;color:#48C9B0;
    display: flex;
    justify-content: space-between;
}
</style>